import { message } from "@timeedit/ui-components/antd";
import { JSXElementConstructor, ReactElement, useEffect } from "react";
import { CapitalizedNoticeType, MessageState, severityTypeMap } from "./types";
import { stringHasContent } from "@timeedit/registration-shared";
import { SeverityIcon } from "../components/SeverityIcons";
import "./UseMessage.scss";

type UseMessageReturn = ReactElement<
  unknown,
  string | JSXElementConstructor<unknown>
>;
export function useMessage(messageState: MessageState): UseMessageReturn {
  const [api, messageContextHolder] = message.useMessage();

  useEffect(() => {
    const { type, duration = 3, content } = messageState;
    if (!stringHasContent(content)) return;

    const severityType: CapitalizedNoticeType = severityTypeMap[type];

    api[type]({
      duration,
      content,
      icon: <SeverityIcon type={severityType} className="use-message__icon" />,
    });
  }, [api, messageState]);

  return messageContextHolder;
}
